<template>
  <div style="padding: 10px">
    <div style="margin: 10px 0">
      <el-select v-model="search.tokenId" placeholder="选择角色" style="width: 20%" clearable filterable>
        <el-option
            v-for="role in roleList"
            :key="role.roleId"
            :label="role.roleName"
            :value="`token_${role.roleId}`">
        </el-option>
      </el-select>

      <el-select v-model="search.logType" placeholder="日志类型" style="width: 20%" clearable>
        <el-option
            v-for="item in logTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="search.error" placeholder="异常报错" style="width: 20%" clearable>
        <el-option
            v-for="item in errorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>

      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
    </div>

    <!--搜索区域-->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="roleName"
          :formatter="formatRoleName"
          label="角色名"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="tokenId"
          label="角色Token"
          :formatter="formatTokenId"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="content"
          label="日志内容"
      >
      </el-table-column>
      <el-table-column
          prop="logTime"
          label="时间"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="logType"
          label="日志类型"
          :formatter="formatLogType"
          width="150"
          show-overflow-tooltip>
      </el-table-column>
    </el-table>

    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'towerFormation',
  components: {},
  data() {
    return {
      dialogVisible: false,
      form: {
        createTime: '',
      },
      userId: '',
      loading: true,
      search: {
        tokenId: '',
        logType: ''
      },
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      roleList: [], // 存储所有角色列表
      logTypeOptions: [
        {label: '未知', value: 0},
        {label: '收菜', value: 1},
        {label: '踢人收人', value: 2},
        {label: '俱乐部信息同步', value: 3},
        {label: '盐场战报同步', value: 4},
        {label: '宝库助力', value: 5},
        {label: '俱乐部签到', value: 6},
        {label: '修改阵容名称', value: 7},
        {label: '每日任务', value: 8},
        {label: '赛车', value: 9},
        {label: '梦境', value: 10},
        {label: '竞技场', value: 11},
        {label: '怪异塔', value: 12},
        {label: '咸将塔', value: 13},
        {label: '消耗活动', value: 14},
      ],
      errorOptions: [{label: '是', value: 1}, {label: '否', value: 0}]
    }
  },
  created() {
    this.loadAllUsers()
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;
  },
  methods: {
    // 格式化角色名称显示
    formatRoleName(row, column, cellValue) {

      // 如果接口返回了roleName，直接显示
      if (cellValue) {
        return cellValue;
      }

      // 如果没有roleName，根据tokenId查找对应的角色名称
      const tokenId = row.tokenId;
      if (tokenId) {
        const roleId = tokenId.toString().replace('token_', '');
        const role = this.roleList.find(item => item.roleId == roleId);
        return role ? role.roleName : `用户${roleId}`;
      }

      return '未知用户';
    },
// 在获取用户信息时，确保有合适的显示名称
    loadAllUsers() {
      request.get("/accountInfoWs/list", {
        params: {
          current: 1,
          size: 200
        }
      }).then(res => {
        if (res.code === '0') {
          const roleMap = new Map();
          res.data.records.forEach(item => {
            if (item.roleId) {
              // 优先使用accountName，如果没有则使用roleName，最后使用默认名称
              const displayName = item.accountName || `用户${item.roleId}`;
              roleMap.set(item.roleId, {
                roleId: item.roleId,
                roleName: displayName
              });
            }
          });
          this.roleList = Array.from(roleMap.values());
        }
      }).catch(error => {
        console.error('获取用户列表失败:', error);
      }).finally(() => {
        this.load();
      });
    },

    // 格式化tokenId显示
    formatTokenId(row, column, cellValue) {
      if (cellValue && cellValue.startsWith('token_')) {
        return cellValue;
      }
      return `token_${cellValue}`;
    },

    // 格式化日志类型显示
    formatLogType(row, column, cellValue) {
      const logTypeMap = {
        0: '未知',
        1: '收菜',
        2: '踢人收人',
        3: '俱乐部信息同步',
        4: '盐场战报同步',
        5: '宝库助力',
        6: '俱乐部签到',
        7: '修改阵容名称',
        8: '每日任务',
        9: '赛车',
        10: '梦境',
        11: '竞技场',
        12: '怪异塔',
        13: '咸将塔',
        14: '消耗活动'
      };
      return logTypeMap[cellValue] || `未知类型(${cellValue})`;
    },

    resetData() {
      this.search = {
        tokenId: '',
        logType: ''
      }
      this.load()
    },

    load() {
      this.loading = true
      const searchForm = {...this.search}

      let obj = Object.assign(searchForm, this.query)
      let reqData = {
        ...obj
      }
      reqData.current = this.currentPage
      reqData.size = this.pageSize

      request.get("/wsLog/list", {
        params: reqData
      }).then(res => {
        this.loading = false

        if (res.code === '0') {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(error => {
        this.loading = false
        this.tableData = []
        this.total = 0
      })
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },

    handleCurrentChange(pageNum) {
      this.currentPage = pageNum
      this.load()
    },
  }
}
</script>
